import Box from '@mui/material/Box';

const logoSrc = `${import.meta.env.BASE_URL}branding/sentinel-logo.png`;

// ==============================|| LOGO MAIN ||============================== //

export default function LogoMain() {
  return (
    <Box
      component="img"
      src={logoSrc}
      alt="BFT Sentinel"
      sx={{
        display: 'block',
        width: { xs: 190, sm: 250 },
        maxWidth: '100%',
        maxHeight: { xs: 56, sm: 68 },
        objectFit: 'contain',
        height: 'auto'
      }}
    />
  );
}
